import getNodeLatLng from "./get-node-lat-lng.js";
import {Types} from "../enums.js";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";

const ICON_BY_TYPE = {
    [Types.PASSAGE]: "img/markers/passage-marker.svg",
    [Types.VEHICLE]: "img/markers/passage-marker.svg",
    [Types.BO]: "img/individual/sw.bogcm.svg",
    [Types.OCCURRENCE]: "img/individual/sw.ocorrencia.svg",
    [Types.SOS]: "img/markers/sos-marker.svg",
    [Types.ENCOUNTER]: "img/individual/sw.abordagem.svg",
    [Types.COINCIDENT_PASSAGES]: "img/markers/passage-marker.svg",
};

const buildMapMarkers = (nodes) => {
    const markers = [];

    for (const node of nodes ?? []) {
        const coords = getNodeLatLng(node);
        if (!coords) continue;

        const iconPath = ICON_BY_TYPE[node.type];

        markers.push({
            id: node.id,
            type: node.type,
            lat: coords.lat,
            lng: coords.lng,
            node,
            icon: iconPath ? getAssetPath(iconPath) : null,
        });
    }

    return markers;
};

export default buildMapMarkers;
